import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('asPartPopupStore', Object.keys(getters)),
	...mapState('asPartPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('asPartPopupStore', Object.keys(actions)),
	...mapMutations('asPartPopupStore', Object.keys(mutations))
};
